// use-upload-profile-image.ts — Current-user suite, action.

'use client';

import { useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/contexts/api';
import { useActionHook } from '@/lib/query/use-action-hook';
import type { ActionResult } from '@/types/async-protocol';
import { currentUserKeys } from './keys';
import type { UserProfile } from './use-current-user';

export function useUploadProfileImage(): ActionResult<{ file: File }, UserProfile> {
  const api = useApi();
  const apiProfile = api.profile;
  const queryClient = useQueryClient();

  return useActionHook<{ file: File }, UserProfile>(
    useMemo(
      () => ({
        mutationFn: async ({ file }) => {
          const formData = new FormData();
          formData.append('image', file);
          await apiProfile.uploadImage({ body: formData });
          return apiProfile.get();
        },
        onInvalidate: (profile) => {
          queryClient.setQueryData(currentUserKeys.profile(), profile);
          queryClient.invalidateQueries({ queryKey: currentUserKeys.profile() });
        },
      }),
      [apiProfile, queryClient],
    ),
  );
}
